import React from 'react';
import { CopyText } from '../../../UiKit';

export const MerchentTagDescription = ({ texts = [] }) => {
  if (!texts || (texts && !texts.length))
    return 'No data available for this tag';
  return (
    <div className='tagDescription'>
      {texts &&
        texts.map((message, index) => {
          return (
            <div key={index} data-dd-privacy='mask'>
              <div
                className='text pb10'
                style={{
                  fontWeight: message.type,
                  color: message.color,
                }}
              >
                <CopyText title={message.text} isLink={true} />
              </div>
              {message.break && <br></br>}
            </div>
          );
        })}
    </div>
  );
};
